<main class="container my-5">
  <section id="profile">
      <div class="container d-flex justify-content-center align-items-center min-vh-100 pt-5">
          <form class="w-100 pt-2">
              <div class="container-fluid main-content col-lg-8 col-md-10 col-12">
                  <app-partner-form (formSubmitted)="onPartnerFormSubmitted($event)"></app-partner-form>
              </div>
          </form>
      </div>
  </section>
</main>
